import { SetStateAction, createContext } from "react";

interface IDefaultLayoutContext {
    setTrialLinkEnabled?: (enable: boolean) => void;
}

const DefaultLayoutContext = createContext<IDefaultLayoutContext>({
    setTrialLinkEnabled: undefined
})

export default DefaultLayoutContext;